import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { CondomanagerApiService } from '../../../../services/api/condomanager-api.service';
import { ICondoManagerImport } from '../../../../types/api-response/condomanager/import';
import { ICondoManagerBuildingFolder } from '../../../../types/api-response/condomanager/building-folder';

declare const toastr: any;

@Component({
    selector: 'condomanager',
    templateUrl: './condomanager.component.html',
    styleUrls: ['./condomanager.component.scss']
})
export class CondomanagerComponent implements OnInit, OnDestroy, OnChanges {

    @Input() buildingId: number;
    @Input() buildingFolder: ICondoManagerBuildingFolder = null;

    spinnerShow = false;
    interval: any;

    public importList: ICondoManagerImport[] = [];

    constructor(
        private condomanagerApiService: CondomanagerApiService
    ) {}

    ngOnInit(): void {

    }

    loadImportList(): void {
        clearTimeout(this.interval);

        this.spinnerShow = true;

        this.condomanagerApiService.getListImport(this.buildingId)
            .finally(() => { this.spinnerShow = false; })
            .subscribe(res => {
                this.importList = res.entities;

                const inProgressImport = this.importList.filter(el => {
                    return el.status == 'in_progress' || el.status == 'wait'
                });

                if (inProgressImport.length) {
                    this.interval = setTimeout(() => {
                        this.loadImportList()
                    }, 5000);
                }
            }, error => {
                this.importList = [];
                toastr.error("List load failed");
            });
    }

    synchronizeFolder() {
        this.spinnerShow = true;
        this.condomanagerApiService.synchronizeFolder(this.buildingFolder.id)
            .finally(() => {
                this.spinnerShow = false;
            })
            .subscribe(res => {
                this.loadImportList();
            }, error => {
                toastr.warning("No changes has been found in the original file since last synchronization");
            });
    }

    ngOnDestroy(): void {
        clearTimeout(this.interval);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.buildingId) {
            this.importList = [];
            this.loadImportList();
        }
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/admin/property/condomanager/condomanager.component.ts